exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".input-group-addon.addon-inside:first-child{border-right-width:1px;border-right-style:solid;border-color:transparent;z-index:999}.logo-login{width:150px}h1.logo-login small{font-size:40%;font-weight:300;color:#1a9be2}h1.logo-login{font-family:Nunito,sans-serif;color:#1a9be2;font-size:60px;text-align:center}.font-white small{color:#dadada}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/login/login.scss
// module id = 908
// module chunks = 0